import type { ComponentProps } from "react"

export default function ChevronDown(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const {
    fill: _ignoredFill,
    stroke = "currentColor",
    strokeWidth = 2,
    strokeLinecap = "round",
    strokeLinejoin = "round",
    ...svgProps
  } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      aria-hidden
      {...svgProps}
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  )
}
